import { useMutation } from "react-query";
import { deleteLE } from "../../../../actions/CarrierAgreementMgmt/LeasedEquipment";

export const useDeleteLE = () => {
  return useMutation(deleteLE);
};
